import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../UserAvatar';
import './index.scss';

export default function EditorialFriendCard({
  userId,
  username,
  name,
  role,
  handle,
  avatarUrl,
  publicMedia = false,
  actionLabel,
  onAction,
  onSelect,
  className = '',
}) {
  const isSelectable = typeof onSelect === 'function';
  const classes = [
    'ed-friend-card',
    isSelectable ? 'ed-friend-card--selectable' : '',
    className,
  ].filter(Boolean).join(' ');
  const hasAction = Boolean(actionLabel) && typeof onAction === 'function';
  const avatarAlt = typeof name === 'string' && name.trim()
    ? `${name.trim()} profile picture`
    : 'Friend profile picture';
  const selectLabel = typeof name === 'string' && name.trim()
    ? `View ${name.trim()} profile`
    : 'View friend profile';
  const handleSelect = (event) => {
    if (!isSelectable) return;
    onSelect(event);
  };
  const handleActionClick = (event) => {
    event.stopPropagation();
    onAction(event);
  };
  const mainContent = (
    <>
      <UserAvatar
        userId={userId}
        username={username}
        className="ed-friend-card__avatar"
        imgClassName="ed-friend-card__avatar-img"
        avatarUrl={avatarUrl || undefined}
        audience={publicMedia ? 'public' : 'viewer'}
        alt={avatarAlt}
        size="48px"
        radius="16px"
        imgProps={{ loading: 'lazy' }}
      />
      <div className="ed-friend-card__body">
        <div className="ed-friend-card__name">{name}</div>
        {role ? <div className="ed-friend-card__role">{role}</div> : null}
        {handle ? <div className="ed-friend-card__handle">{handle}</div> : null}
      </div>
    </>
  );

  return (
    <article className={classes}>
      {isSelectable ? (
        <button
          type="button"
          className="ed-friend-card__select"
          aria-label={selectLabel}
          onClick={handleSelect}
        >
          {mainContent}
        </button>
      ) : (
        <div className="ed-friend-card__select">
          {mainContent}
        </div>
      )}
      {hasAction ? (
        <button type="button" className="ed-friend-card__btn" onClick={handleActionClick}>
          {actionLabel}
        </button>
      ) : null}
    </article>
  );
}

EditorialFriendCard.propTypes = {
  userId: PropTypes.string,
  username: PropTypes.string,
  name: PropTypes.node.isRequired,
  role: PropTypes.node,
  handle: PropTypes.node,
  avatarUrl: PropTypes.string,
  publicMedia: PropTypes.bool,
  actionLabel: PropTypes.node,
  onAction: PropTypes.func,
  onSelect: PropTypes.func,
  className: PropTypes.string,
};
